import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { memo } from "react";
export const CameraDetailsItem = /*#__PURE__*/ memo((param)=>{
    let { text, Icon, label } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-1",
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                label: label,
                side: "left",
                children: /*#__PURE__*/ _jsx(Icon, {
                    className: "size-4 text-grey-8"
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-12 text-grey-12",
                children: text
            })
        ]
    });
});
CameraDetailsItem.displayName = "CameraDetailsItem";
